import { roomMemberType } from "./roomMemberType.ts";
import { worldVfsMemberKind, type CanvasContentType } from "./roomUniverse.ts";

/** Display lenses, never a new storage group or a context-selection rule. */
export type ContextContentKind =
  | "canvas"
  | "blueprint"
  | "board-component"
  | "media"
  | "history"
  | "crm"
  | "contacts"
  | "mobile-app"
  | "files"
  | "other";
export function contextContentKind(
  id: string,
  contentType?: CanvasContentType,
): ContextContentKind {
  if (roomMemberType(id) === "company") return "crm";
  if (roomMemberType(id) === "contact") return "contacts";
  // MA7/MA10: a World mobile app is one structured VFS member (mobileAppMembers.js).
  if (id.startsWith("world-vfs:mobile-apps/")) return "mobile-app";
  if (/^world-vfs:library\/(image|video|audio)\//.test(id)) return "media";
  if (id.startsWith("world-vfs:")) {
    const kind = worldVfsMemberKind(id);
    return kind === "canvas" && contentType === "idea" ? "blueprint" : (kind ?? "other");
  }
  // Stored transcript identities are minted by transcriptWorldStorage, not inferred from a title.
  if (id.startsWith("world-r2:context/sessions/") && id.endsWith(".md")) return "history";
  if (id.startsWith("world-r2:")) {
    const type = roomMemberType(id);
    return type === "image" || type === "video" || type === "audio" ? "media" : "files";
  }
  return "other";
}
